import { Cookies } from 'react-cookie';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const updateTrapActivationSignalComment = async (
  signalId: number,
  type: string,
  comment?: string,
  removeComment?: boolean,
) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.put(
    `/update-trap-activation-signal-comment/${signalId}/`,
    {
      comment,
      remove_comment: removeComment,
      type: type,
    },
    {
      headers: {
        Authorization: token,
      },
    },
  );
  return data.data;
};
